const styles = () => ({
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  headline: {
    color: '#596168',
    fontSize: 15,
    margin: '0 auto',
    maxWidth: 480,
    textAlign: 'center',
    fontWeight: 500,
    lineHeight: '20px',
  },

  typeToggle: {
    margin: '8px 0 28px',
  },

  link: {
    textDecoration: 'underline',
  },

  break: {
    border: '0.5px solid #e1e9f0',
    width: 480,
    margin: '23px auto 23px',
  },

  description: {
    color: '#596168',
    fontSize: 15,
    maxWidth: 500,
    padding: '0 10px',
    textAlign: 'center',
  },

  connectButton: {
    fontSize: 15,
    padding: '5px 16px',
    height: '36px',
    lineHeight: '26px',
  },

  textField: {
    display: 'flex',
    margin: '24px 0',
    width: '400px',
  },

  buttons: {
    textAlign: 'center',

    '& button': {
      display: 'inline-block',
      margin: '0px 8px',
    },
  },
});

export default styles;
